export const UNMAPPED_COLORS = {
  blueGradient: '#03a9f4',
  lightBlueGradient: '#E8F6FC',
  lightRedGradient: '#F8E8E8',
  lightPurpleGradient: '#F2EEF9',
  lightYellowGradient: '#FEF2E6',
  lightGreenGradient: '#EDF7EE',
  darkGrayGradient: '#3E3E3E',
  blueGradient2: '#02557a',
}
